import { Component, OnInit } from '@angular/core';
import {
  OkantNamnStatus,
  Oversikt,
  ParkComment,
} from '../../../shared/models/manuell-atgard';
import { FormControl, FormGroup } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AtgardsListaService } from '../atgards-lista.service';
import { ParkeringDTO } from '../../models/parkera';
import { NameType } from '../../../shared/models/models';

interface Record {
  user: string;
  created: Date;
  kommentar: string;
  status?: OkantNamnStatus;
}

@Component({
    selector: 'lib-historik-dialog',
    templateUrl: './historik-dialog.component.html',
    styleUrls: ['./historik-dialog.component.scss'],
    standalone: false
})
export class HistorikDialogComponent implements OnInit {
  commentForm = new FormGroup({
    comment: new FormControl(''),
  });

  atgardatNamn? = '';
  atgard?: Record;
  loading = false;
  records!: ParkComment[];
  currentOveriktRow!: Oversikt;

  constructor(
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private atgardsService: AtgardsListaService
  ) {}

  ngOnInit(): void {
    //TODO - Get real data
    this.currentOveriktRow = this.config.data.atgard;

    this.atgardatNamn = this.currentOveriktRow.name;
    this.records = this.currentOveriktRow.parking_comments;
  }

  async addComment() {
    this.loading = true;

    const parkeraDTO: ParkeringDTO = {
      name: this.currentOveriktRow.name,
      labb_kod: this.currentOveriktRow.labCode,
      comments: this.commentForm.value.comment ?? '',
      nameType: this.currentOveriktRow.type as NameType,
    };

    await this.atgardsService.addComment(parkeraDTO);
    this.ref.close();
  }

  getToastStatusType(status: OkantNamnStatus): 'warning' | 'success' {
    return status === OkantNamnStatus.Parkerad ? 'warning' : 'success';
  }

  getStatusText(status: OkantNamnStatus): string {
    switch (status) {
      case OkantNamnStatus.Ignorerad:
        return 'Ignorerad';
      case OkantNamnStatus.Parkerad:
        return 'Parkerad';
      case OkantNamnStatus.Synonymiserad:
      case OkantNamnStatus.NyttStandardnamn:
        return 'Synonymiserad';
      default:
        return '';
    }
  }
}
